import types from '../types/adminUserRequestActionTypes';

export const setUserRequestData = (payload) => {
	return { type: types.SET_USER_REQUEST_DATA, payload }
}